import React from 'react';

const FuelTransitionIcon = () => {
  return (
    <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="18.000000pt"
    height="18.000000pt"
    viewBox="0 0 1024.000000 1024.000000"
    preserveAspectRatio="xMidYMid meet"
    fill='#fff'
  >
    <g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)" fill="#bebebe" stroke="none">
      <path
        d="M3055 8494 c-278 -30 -609 -113 -880 -221 -999 -396 -1761 -1217
-2045 -2204 -189 -659 -173 -1402 45 -2037 205 -600 570 -1118 1074 -1527 516
-418 1174 -692 1823 -760 169 -17 507 -20 659 -5 444 44 882 180 1271 396
l118 64 127 -70 c394 -215 830 -349 1268 -390 162 -15 484 -12 653 5 994 103
1944 671 2501 1495 226 335 369 649 466 1026 75 291 100 499 100 844 -1 279
-10 391 -51 620 -186 1021 -839 1907 -1766 2394 -372 196 -764 316 -1203 368
-144 17 -597 17 -735 0 -444 -54 -806 -166 -1198 -367 l-163 -85 -127 70
c-390 214 -818 346 -1261 390 -143 14 -520 11 -676 -6z m3929 -584 c988 -64
1865 -625 2344 -1500 54 -99 133 -284 176 -412 161 -485 179 -1045 50 -1563
-235 -942 -967 -1707 -1904 -1988 -237 -72 -451 -106 -715 -114 -351 -11 -656
34 -985 145 -93 32 -290 110 -290 116 0 0 62 64 138 141 332 337 572 704 745
1140 99 248 177 547 207 790 6 50 13 105 16 123 l5 32 421 0 421 0 -71 -74
c-93 -95 -117 -146 -116 -246 0 -66 4 -83 34 -139 78 -146 245 -200 394 -127
39 19 130 105 397 373 387 389 384 385 384 518 0 124 -8 135 -402 526 -322
320 -352 348 -406 368 -118 43 -219 20 -314 -74 -48 -48 -65 -73 -77 -115 -37
-125 -11 -212 101 -330 l75 -80 -420 0 -421 0 -6 48 c-47 361 -109 613 -222
897 -177 446 -444 848 -782 1179 -56 54 -100 100 -99 101 14 12 126 61 228
100 230 87 511 148 765 165 161 10 166 10 329 0z m-3181 -24 c410 -67 765
-204 1107 -430 681 -449 1149 -1176 1243 -1931 l13 -100 -891 -5 -890 -5 -50
-27 c-102 -54 -158 -141 -163 -254 -4 -62 0 -81 23 -133 30 -66 78 -116 147
-153 l43 -23 890 -5 891 -5 -13 -105 c-71 -559 -357 -1124 -788 -1555 -435
-434 -964 -704 -1571 -802 -170 -28 -620 -25 -809 5 -1206 189 -2136 1098
-2344 2292 -179 1025 238 2072 1075 2701 389 292 870 486 1334 538 52 6 109
13 125 15 74 10 535 -3 628 -18z"
      />
    </g>
  </svg>
  );
};

export default FuelTransitionIcon;
